<div class="c">

  <div id="map">
    <mat-spinner id="loading" *ngIf="loading"></mat-spinner>
  </div>
  <div class="getloc">
    <button mat-fab class="locbtn" color="white" aria-label="profile icon"
            (click)="getLocation()">
      <mat-icon>my_location</mat-icon>
    </button>
  </div>


  <!-- Modal content -->
  <div [class]="display">
    <div [class]="displayAlert">
      <div class="modal-header">
        <p [class]="displayTitr1">لطفا آدرس خود را اصلاح و یا تکمیل کنید</p>
        <p [class]="displayTitr2">لطفا آدرس خود را وارد کنید</p>
        <!-- <span class="close" (click)="closeClick()">&times;</span> -->
      </div>
      <div class="modal-body">
        <div dir="rtl">
          <!-- <input mat-input class="inputadr" type="text" id="myText" value="Mickey" [(ngModel)]="publicservice.location"> -->
          <mat-form-field appearance="outline" class="inputadr">
            <input matInput type="text" id="myText" value="{{formattedData}}" [(ngModel)]="publicservice.location"
                   [formControl]="address">
            <mat-error *ngIf="address.hasError('required')" class="error">
              {{publicservice.Texts.Texts["get-location1"]}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="modal-footer">
        <div class="back-btn">
          <button mat-button class="selectbtn" type="button" class="back" (click)="okClick()">
            <p style="width: 40px; height: 20px;"> تایید </p>
          </button>
          <button mat-button class="selectbtn" type="button" class="back" (click)="closeClick()">
            <p style="width: 40px; height: 20px;"> انصراف </p>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="done-btn">
      <button mat-button type="button" class="done" (click)="doneclick()">
          {{publicservice.Texts.Texts['selected-items3']}}</button>
  </div> -->

</div>
